module.exports = __webpack_public_path__ + "static/media/wizualizacja-101.8dfc9b02.png";